import React, { useLayoutEffect, useEffect } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { NotFound } from "./components";
import { OfferListItemLarge, Button } from "src/components";
import { useOwnOffers } from "src/hooks";
import { useNavigation } from "@react-navigation/native";
import { tabChangeEmit } from "src/utils/event";
import { MainTabScreenProps } from "src/navigation/types";

export const OffersScreen: React.FC = () => {
  const navigation =
    useNavigation<MainTabScreenProps<"Offers">["navigation"]>();
  const [items, loading] = useOwnOffers();
  useLayoutEffect(() => {
    navigation.setOptions({
      headerRight: () =>
        items.length > 0 && !loading ? (
          <Button
            onPress={() => navigation.push("OfferEdit", {})}
            variant={"icon"}
            icon={"plus-circle-arrows"}
            iconSize={24}
            iconColor={colors.chokuRed}
            containerStyle={styles.headerButton}
          />
        ) : null,
    });
  }, [navigation, items, loading]);
  useEffect(() => {
    const unsubscribe = navigation.addListener("focus", (e) => {
      tabChangeEmit("Offers");
    });
    return () => {
      unsubscribe();
    };
  }, [navigation]);
  return (
    <View
      style={[
        styles.container,
        !loading && items.length === 0 ? styles.notFound : {},
      ]}
    >
      {!loading && items.length === 0 ? (
        <NotFound onCreate={() => navigation.push("OfferEdit", {})} />
      ) : null}
      {items.length > 0 ? (
        <ScrollView showsVerticalScrollIndicator={false}>
          {items.map((item, index) => (
            <OfferListItemLarge
              key={index}
              offerName={item.title}
              offerImageSource={
                item.mainImageUrl ? { uri: item.mainImageUrl } : undefined
              }
              categoryName={item.category?.title || "unknown"}
              price={item.price || 0}
              likes={item.likeCount}
              pv={item.views || 0}
              isPublic={item.isPublic}
              createdAt={item.createdAt}
              isVerified={item.owner?.identificationStatus === "APPROVED"}
              rate={item.rate}
              rateCount={item.rateCount}
              onPress={() => navigation.push("OfferEdit", { offerId: item.id })}
            />
          ))}
        </ScrollView>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  notFound: {
    backgroundColor: colors.gray1,
  },
  headerButton: {
    marginRight: 16,
  },
});
